<div class="supplier-document">
  <button type="button" class="section-toggle" (click)="toggleExpanded()">
    <span>📄 {{ toggleTitleText }}</span>
    <span class="chevron" [class.open]="expanded">▾</span>
  </button>

  <div class="section-body" *ngIf="expanded">
    <div *ngIf="loading" class="loading-message">{{ loadingText }}</div>
    <div *ngIf="error" class="error-message">{{ error }}</div>

    <ng-container *ngIf="!loading && document">
      <p class="hint" *ngIf="!readonlyMode">
        {{ hintEditableText }}
      </p>
      <p class="hint" *ngIf="readonlyMode && !document.saved">
        {{ hintReadonlyNotSavedText }}
      </p>

      <div class="doc-actions">
        <button type="button" class="btn btn-primary" *ngIf="!readonlyMode" [disabled]="saving" (click)="save()">
          {{ saving ? savingText : saveText }}
        </button>
        <span class="saved-message" *ngIf="savedMessage">✓ {{ savedMessage }}</span>
        <button type="button" class="btn btn-secondary" (click)="downloadCI()">{{ downloadCIText }}</button>
        <button type="button" class="btn btn-secondary" (click)="downloadPL()">{{ downloadPLText }}</button>
      </div>

      <div class="doc-form" [class.readonly]="readonlyMode">
        <div class="form-grid">
          <div class="form-group">
            <label>{{ fieldSellerNameText }}</label>
            <input type="text" [(ngModel)]="document.sellerName" [disabled]="readonlyMode" />
          </div>
          <div class="form-group">
            <label>{{ fieldSellerAddressText }}</label>
            <input type="text" [(ngModel)]="document.sellerAddress" [disabled]="readonlyMode" />
          </div>
          <div class="form-group">
            <label>{{ fieldBuyerNameText }}</label>
            <input type="text" [(ngModel)]="document.buyerName" [disabled]="readonlyMode" />
          </div>
          <div class="form-group">
            <label>{{ fieldBuyerAddressText }}</label>
            <input type="text" [(ngModel)]="document.buyerAddress" [disabled]="readonlyMode" />
          </div>
          <div class="form-group">
            <label>{{ fieldShipperNameText }}</label>
            <input type="text" [(ngModel)]="document.shipperName" [disabled]="readonlyMode" [placeholder]="placeholderSameAsSellerText" />
          </div>
          <div class="form-group">
            <label>{{ fieldConsigneeNameText }}</label>
            <input type="text" [(ngModel)]="document.consigneeName" [disabled]="readonlyMode" [placeholder]="placeholderSameAsBuyerText" />
          </div>
          <div class="form-group">
            <label>{{ fieldInvoiceNumberText }}</label>
            <input type="text" [(ngModel)]="document.invoiceNumber" [disabled]="readonlyMode" />
          </div>
          <div class="form-group">
            <label>{{ fieldInvoiceDateText }}</label>
            <input type="text" [(ngModel)]="document.invoiceDate" [disabled]="readonlyMode" />
          </div>
          <div class="form-group">
            <label>{{ fieldYourOrderNoText }}</label>
            <input type="text" [(ngModel)]="document.yourOrderNo" [disabled]="readonlyMode" />
          </div>
          <div class="form-group">
            <label>{{ fieldOurOrderNoText }}</label>
            <input type="text" [(ngModel)]="document.ourOrderNo" [disabled]="readonlyMode" />
          </div>
          <div class="form-group">
            <label>{{ fieldDocumentaryCreditNoText }}</label>
            <input type="text" [(ngModel)]="document.documentaryCreditNo" [disabled]="readonlyMode" />
          </div>
          <div class="form-group">
            <label>{{ fieldIssuedByBankText }}</label>
            <input type="text" [(ngModel)]="document.issuedByBank" [disabled]="readonlyMode" />
          </div>
          <div class="form-group">
            <label>{{ fieldVesselAircraftText }}</label>
            <input type="text" [(ngModel)]="document.vesselAircraft" [disabled]="readonlyMode" />
          </div>
          <div class="form-group">
            <label>{{ fieldFromLocationText }}</label>
            <input type="text" [(ngModel)]="document.fromLocation" [disabled]="readonlyMode" />
          </div>
          <div class="form-group">
            <label>{{ fieldToLocationText }}</label>
            <input type="text" [(ngModel)]="document.toLocation" [disabled]="readonlyMode" />
          </div>
          <div class="form-group">
            <label>{{ fieldCountryOfOriginText }}</label>
            <input type="text" [(ngModel)]="document.countryOfOrigin" [disabled]="readonlyMode" />
          </div>
          <div class="form-group">
            <label>{{ fieldTermsOfDeliveryText }}</label>
            <input type="text" [(ngModel)]="document.termsOfDelivery" [disabled]="readonlyMode" />
          </div>
          <div class="form-group">
            <label>{{ fieldCurrencyText }}</label>
            <input type="text" [(ngModel)]="document.currencyCode" [disabled]="readonlyMode" placeholder="CNY" />
          </div>
        </div>

        <div class="items-table">
          <table>
            <thead>
              <tr>
                <th>{{ columnDescriptionText }}</th>
                <th>{{ columnQuantityText }}</th>
                <th>{{ columnUnitPriceText }}</th>
                <th>{{ columnAmountText }}</th>
                <th>{{ columnCartonsText }}</th>
                <th>{{ columnNetWeightText }}</th>
                <th>{{ columnGrossWeightText }}</th>
                <th>{{ columnVolumeText }}</th>
                <th *ngIf="!readonlyMode"></th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of document.items; let i = index">
                <td class="description-cell">
                  <input type="text" [(ngModel)]="item.description" [disabled]="readonlyMode" [placeholder]="placeholderDescriptionText" />
                  <input type="text" [(ngModel)]="item.hsCode" [disabled]="readonlyMode" [placeholder]="placeholderHsCodeText" class="hs-code-input" />
                </td>
                <td><input type="number" [(ngModel)]="item.quantity" [disabled]="readonlyMode" /></td>
                <td><input type="number" [(ngModel)]="item.unitPrice" [disabled]="readonlyMode" /></td>
                <td><input type="number" [(ngModel)]="item.amount" [disabled]="readonlyMode" /></td>
                <td><input type="number" [(ngModel)]="item.cartons" [disabled]="readonlyMode" /></td>
                <td><input type="number" [(ngModel)]="item.netWeightKg" [disabled]="readonlyMode" /></td>
                <td><input type="number" [(ngModel)]="item.grossWeightKg" [disabled]="readonlyMode" /></td>
                <td><input type="number" [(ngModel)]="item.volumeCbm" [disabled]="readonlyMode" /></td>
                <td *ngIf="!readonlyMode">
                  <button type="button" class="btn-remove" (click)="removeItem(i)">✕</button>
                </td>
              </tr>
            </tbody>
          </table>
          <button type="button" class="btn btn-link" *ngIf="!readonlyMode" (click)="addItem()">{{ addRowText }}</button>
        </div>
      </div>
    </ng-container>
  </div>

  <!-- Скрытые шаблоны для генерации PDF (html2pdf рендерит из DOM) -->
  <div class="pdf-template" #ciTemplate *ngIf="document">
    <h1>COMMERCIAL INVOICE</h1>
    <table class="pdf-header-table">
      <tr>
        <td class="pdf-header-cell">
          <strong>Seller (Name, Address.):</strong><br />
          {{ document.sellerName }}<br />
          {{ document.sellerAddress }}
        </td>
        <td class="pdf-header-cell">
          <strong>Shipper (if different from Seller):</strong><br />
          {{ document.shipperName || 'Same as Seller' }}<br />
          {{ document.shipperAddress }}
        </td>
      </tr>
      <tr>
        <td class="pdf-header-cell">
          <strong>Buyer (Name, Address.):</strong><br />
          {{ document.buyerName }}<br />
          {{ document.buyerAddress }}
        </td>
        <td class="pdf-header-cell">
          <strong>Consignee (if different from Buyer):</strong><br />
          {{ document.consigneeName || 'Same as Buyer' }}<br />
          {{ document.consigneeAddress }}
        </td>
      </tr>
      <tr>
        <td class="pdf-header-cell">
          Invoice NO. {{ document.invoiceNumber }}<br />
          Date {{ document.invoiceDate }}<br />
          Your Order No. {{ document.yourOrderNo }}<br />
          Our Order NO. {{ document.ourOrderNo }}<br />
          Documentary Credit No. {{ document.documentaryCreditNo }}
        </td>
        <td class="pdf-header-cell">
          Issued by (Bank &amp; Branch)<br />
          {{ document.issuedByBank }}
        </td>
      </tr>
      <tr>
        <td class="pdf-header-cell">
          Vessel/Aircraft etc. {{ document.vesselAircraft }}<br />
          From {{ document.fromLocation }}<br />
          To {{ document.toLocation }}
        </td>
        <td class="pdf-header-cell">
          Country of Origin of Goods<br />
          {{ document.countryOfOrigin }}<br />
          Terms of Delivery and payment<br />
          {{ document.termsOfDelivery }}
        </td>
      </tr>
    </table>

    <table class="pdf-items-table">
      <thead>
        <tr>
          <th>Description of Goods (English/Russian)</th>
          <th>Quantity (PCS)</th>
          <th>Unit Price {{ document.currencyCode }}</th>
          <th>Amount {{ document.currencyCode }}</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of document.items">
          <td>{{ item.description }}<br /><span class="hs">HS CODE {{ item.hsCode }}</span></td>
          <td class="num">{{ item.quantity }}</td>
          <td class="num">{{ item.unitPrice }}</td>
          <td class="num">{{ item.amount | number:'1.2-2' }}</td>
        </tr>
        <tr class="total-row">
          <td colspan="3">TOTAL:</td>
          <td class="num">{{ getTotalAmount() | number:'1.2-2' }}</td>
        </tr>
      </tbody>
    </table>

    <div class="pdf-stamp">Stamp or signature</div>
  </div>

  <div class="pdf-template" #plTemplate *ngIf="document">
    <h1>PACKING LIST</h1>
    <table class="pdf-header-table">
      <tr>
        <td class="pdf-header-cell">
          <strong>Seller (Name, Address.):</strong><br />
          {{ document.sellerName }}<br />
          {{ document.sellerAddress }}
        </td>
        <td class="pdf-header-cell">
          <strong>Shipper (if different from Seller):</strong><br />
          {{ document.shipperName || 'Same as Seller' }}<br />
          {{ document.shipperAddress }}
        </td>
      </tr>
      <tr>
        <td class="pdf-header-cell">
          <strong>Buyer (Name, Address.):</strong><br />
          {{ document.buyerName }}<br />
          {{ document.buyerAddress }}
        </td>
        <td class="pdf-header-cell">
          <strong>Consignee (if different from Buyer):</strong><br />
          {{ document.consigneeName || 'Same as Buyer' }}<br />
          {{ document.consigneeAddress }}
        </td>
      </tr>
      <tr>
        <td class="pdf-header-cell">
          Invoice NO. {{ document.invoiceNumber }}<br />
          Date {{ document.invoiceDate }}
        </td>
        <td class="pdf-header-cell">
          Vessel/Aircraft etc. {{ document.vesselAircraft }}<br />
          From {{ document.fromLocation }} → To {{ document.toLocation }}
        </td>
      </tr>
      <tr>
        <td class="pdf-header-cell">
          Country of Origin of Goods<br />
          {{ document.countryOfOrigin }}
        </td>
        <td class="pdf-header-cell">
          Terms of Delivery and payment<br />
          {{ document.termsOfDelivery }}
        </td>
      </tr>
    </table>

    <table class="pdf-items-table">
      <thead>
        <tr>
          <th>Description of Goods (English/Russian)</th>
          <th>Q-TY (PCS)</th>
          <th>CTNS</th>
          <th>N.W. (KGS)</th>
          <th>G.W. (KGS)</th>
          <th>TTL CBM</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of document.items">
          <td>{{ item.description }}<br /><span class="hs">HS CODE {{ item.hsCode }}</span></td>
          <td class="num">{{ item.quantity }}</td>
          <td class="num">{{ item.cartons }}</td>
          <td class="num">{{ item.netWeightKg | number:'1.2-2' }}</td>
          <td class="num">{{ item.grossWeightKg | number:'1.2-2' }}</td>
          <td class="num">{{ item.volumeCbm | number:'1.2-2' }}</td>
        </tr>
        <tr class="total-row">
          <td>TOTAL:</td>
          <td class="num">{{ getTotalQuantity() }}</td>
          <td class="num">{{ getTotalCartons() }}</td>
          <td class="num">{{ getTotalNetWeight() | number:'1.2-2' }}</td>
          <td class="num">{{ getTotalGrossWeight() | number:'1.2-2' }}</td>
          <td class="num">{{ getTotalVolume() | number:'1.2-2' }}</td>
        </tr>
      </tbody>
    </table>

    <div class="pdf-stamp">Stamp or signature</div>
  </div>
</div>
